import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./ProductConfigurator.scss";
import { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { QuantitySelector } from "../QuantitySelector/QuantitySelector";
import { GRINDING_OPTIONS } from "@/utils/constants";
import { setCart, setShowCart, setShowToast, setToastMessage, } from "@/utils/constants/redux/sets";
import store from "@/app/providers/redux/store";
export const ProductConfigurator = ({ product, }) => {
    const [quantity, setQuantity] = useState(1);
    const [grinding, setGrinding] = useState(GRINDING_OPTIONS[0].id);
    const { cart } = store.getState().main.session;
    const handleAddToCart = () => {
        const cartItemId = `${product.id}-${grinding}`;
        const existingItemIndex = cart.findIndex((item) => item.id === cartItemId);
        const newCart = [...cart];
        if (existingItemIndex >= 0) {
            newCart[existingItemIndex] = {
                ...newCart[existingItemIndex],
                quantity: (newCart[existingItemIndex].quantity || 1) + quantity,
            };
        }
        else {
            const item = { ...product, id: cartItemId, quantity, grinding };
            newCart.push(item);
        }
        setCart(newCart);
        setShowCart(true);
        setShowToast(true);
        setToastMessage("Producto agregado al carrito");
    };
    return (_jsxs(Form, { className: "mt-4 configurator-controls", children: [_jsxs(Row, { children: [_jsx(Col, { children: _jsxs(Form.Group, { children: [_jsx(Form.Label, { children: "Molienda" }), _jsx(Form.Select, { value: grinding, onChange: (e) => setGrinding(e.target.value), children: GRINDING_OPTIONS.map((option) => (_jsx("option", { value: option.id, children: option.value }, option.id))) })] }) }), _jsx(Col, { children: _jsx(QuantitySelector, { quantity: quantity, setQuantity: setQuantity }) })] }), _jsx("div", { className: "add-to-cart-wrapper", children: _jsx(Button, { className: "add-to-cart-btn", disabled: !product.stock, onClick: handleAddToCart, children: product.stock ? "Añadir al Carrito" : "Producto agotado" }) })] }));
};
